export default "__VITE_ASSET__d1bda4cd__"